import ApiService from '@/services/api'
import { defineStore } from 'pinia'
//import { taskUpdateService } from '@/rxjsServices';

const ENDPOINT = '/zones/'
const ITEM_ID  = 'zon_id'

export const useZoneStore = defineStore('zones', {
    //storage option
    persist: true,
    // convert to a function
    state: () => ({
        item: { 
          zon_id: 0, zon_sta_id: 'GEN01', zon_usr_id: null, zon_name: '', zon_visibility: 1, zon_color: 'blue', zon_icon: null, zon_geojson: null
        },
        itemList: [],
        itemSearchList: '',
        metaTask: {}
    }),
    getters: {
        itemListById() {
            let itemsObject = {}
            for (let i=0, len=this.itemList.length; i<len; i++){
                if( !this.itemList[i].zon_visibility ){ continue; }
                itemsObject[ this.itemList[i].zon_id ] = this.itemList[i]
            }
            return itemsObject
        },
    },
    actions: {
        fetchItem (id, options) {
            return new Promise( (resolve, reject) => {
                options = (options) ? '/' + options : ''
                ApiService.get(ENDPOINT + id + options).then( (response) => {
                    this.SET_ITEM(response.data.data)
                    resolve(this.item)
                }).catch( (error) => { 
                    reject(error)
                })
            })
        },
        fetchItems (options) {
          return new Promise( (resolve, reject) => {
            options = (options) ? options : ''
            ApiService.get( ENDPOINT + options ).then( (response) => {
              this.metaTask = response.data.meta
              if( Object.prototype.toString.call( response.data.data ) === '[object Array]' ) {
                this.SET_ITEMS(response.data.data)
              }
              resolve('resolved')
            }).catch( (error) => { 
              reject(error)
            })
          })
        },
        storeItem () {
          return new Promise( (resolve, reject) => {
            ApiService.post( ENDPOINT, this.item ).then( (response) => {
              this.SET_ITEM(response.data)
              resolve(this.item)
            }).catch( (error) => { 
              reject(error)
            })
          })
        },
        updateItem () {
          return new Promise( (resolve, reject) => {
            ApiService.put( ENDPOINT + this.item[ITEM_ID], this.item ).then( (response) => {
              this.SET_ITEM(response.data)
              resolve(this.item)
            }).catch( (error) => { 
              reject(error)
            })
          })
        },
        destroyItem (id) {
          return new Promise( (resolve, reject) => {
            this.item[ITEM_ID] = (id) ? id : this.item[ITEM_ID]
            ApiService.delete(ENDPOINT + this.item[ITEM_ID]).then( () => {
              resolve('resolved')
            }).catch( (error) => { 
              reject(error)
            })
          })
        },
        //***************************MUTATIONS ***************************************/
        SET_ITEM (item) {
        this.item = item
        },
        SET_ITEMS (itemList) {
        this.itemList = itemList
        },
        RESET_ITEM () {
            this.item = { zon_id: 0, zon_sta_id: 'GEN01', zon_usr_id: null, zon_name: '', zon_visibility: 1, zon_color: 'blue', zon_icon: null, zon_geojson: null }
        }
    }
})
